import { DiagramDefinition } from "../types";

export const m006Definition: DiagramDefinition = {
  id: "M-006",
  title: "Embedded Dual-Database Architecture",
  description:
    "Connection pool controller partitioning read/write queries between data.db (with Write-Ahead Logging WAL) and auxiliary.db (for audit logs and rate limits).",
  viewBox: "0 0 800 360",
  nodes: [
    { id: "Engine", kind: "service", label: "Solarch Engine", subtext: "App Process", position: [400, 50], size: [160, 46] },
    { id: "Pool", kind: "service", label: "Connection Pool", subtext: "Query Router", position: [400, 140], size: [160, 46] },

    // Data DB Cluster
    { id: "DataConn1", kind: "database", label: "Data Conn 1", subtext: "Read / Write", position: [170, 240], size: [140, 46] },
    { id: "DataConn2", kind: "database", label: "Data Conn 2", subtext: "Concurrent Read", position: [330, 240], size: [140, 46] },
    { id: "WAL1", kind: "database", label: "data.db-wal", subtext: "Write-Ahead Log", position: [250, 320], size: [150, 42] },

    // Aux DB Cluster
    { id: "AuxConn1", kind: "database", label: "Aux Conn 1", subtext: "System Logs", position: [490, 240], size: [140, 46] },
    { id: "AuxConn2", kind: "database", label: "Aux Conn 2", subtext: "Audit & Limits", position: [650, 240], size: [140, 46] },
    { id: "WAL2", kind: "database", label: "auxiliary.db-wal", subtext: "Write-Ahead Log", position: [570, 320], size: [150, 42] },
  ],
  edges: [
    { id: "e1", source: "Engine", target: "Pool", sourcePort: "bottom", targetPort: "top", routing: "straight", animated: true },
    { id: "e2", source: "Pool", target: "DataConn1", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e3", source: "Pool", target: "DataConn2", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e4", source: "Pool", target: "AuxConn1", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e5", source: "Pool", target: "AuxConn2", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e6", source: "DataConn1", target: "WAL1", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e7", source: "AuxConn1", target: "WAL2", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
  ],
};
